import { StampedModel } from './StampedModel';

class RestoreableModel extends StampedModel {
  public deleted_at: string;
}

export { RestoreableModel };